/**
 * Return a copy of the object but without passed keys
 * @example
 * const object = {
 *   foo: 'hello',
 *   bar: 'world '
 * }
 * omitKeys(object, ['bar'])
 * // { foo: 'hello' }
 */
export const omitKeys = (object, keysToDelete) => {
  const clonedObject = {
    ...object
  };
  for (const path of keysToDelete) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete clonedObject[path];
  }
  return clonedObject;
};
//# sourceMappingURL=omitKeys.js.map